// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"32dce9ae","687":"17ea2f4f"}[chunkId] + ".chunk.css";
};